// src/components/LoginPromptModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPromptModal.css'; // Use the new dedicated CSS file

const LoginPromptModal = ({ onClose }) => {
    const navigate = useNavigate();

    const handleLogin = () => {
        navigate('/login');
    };

    return (
        <div className="modal-overlay">
            <div className="prompt-modal-content">
                <span className="prompt-icon material-icons">login</span>
                <h2>Log In for Full Access</h2>
                <p>Create an account or log in to save your progress, bookmark content, and join the conversation.</p>
                <div className="prompt-actions">
                    <button onClick={onClose} className="btn-secondary">Continue as Guest</button>
                    <button onClick={handleLogin} className="btn-primary">Login or Sign Up</button>
                </div>
            </div>
        </div>
    );
};

export default LoginPromptModal;